import React from 'react';

import { PageLayout } from 'src/components/common';
import { PartnershipsTable } from 'src/components/partnership';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { InvitePeoByCVStaffModal } from 'src/modals/peo';
import { InvitePeoPayrollProviderByCVStaffModal } from 'src/modals/peoPayrollProvider';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PartnershipsPage: React.FC = () => {
  return (
    <PageLayout titleContent="Partnerships" paperSx={pageLayoutPaperSx}>
      <TableDataProvider>
        <PartnershipsTable />
      </TableDataProvider>

      <InvitePeoByCVStaffModal />
      <InvitePeoPayrollProviderByCVStaffModal />
    </PageLayout>
  );
};
